/** Web never calls the native picker (the screen uses <input type="file">). */
export interface PickedFile { name: string; uri: string; type: string }
export async function pickCsvFile(): Promise<PickedFile | null> { return null; }
